import { Container } from "@bryntum/schedulerpro";

export default class SettingsTabBase extends Container {
  static get $name() {
    return 'SettingsTabBase';
  }

  // Factoryable type name
  static get type() {
    return 'settingsbabbase';
  }

  static get configurable() {
    return {
      flex: "1 0 100%",
      scrollable: true,
      cls: "flex flex-col"
    };
  }

  // unify API with other editors
  editRecord(record, context, otherParams) {
    this.loading = true;
    this.stateProvider = context.stateProvider;
    this.loadRecord(record, context, otherParams);
    this.loading = false;
  }

  loadRecord(record, context, otherParams) {
    this.record = record;
    this.context = context;
    Object.assign(this, context, otherParams);
    this.swivuCheckGrants(context.user);
  }

  swivuCheckGrants() {
  }
}

SettingsTabBase.initClass();
